var map = {
	"./douyin/1.jpg": 7764,
	"./douyin/2.jpg": 9571,
	"./douyin/3.jpg": 4870,
	"./douyin/4.jpg": 1869,
	"./douyin/5.jpg": 4768,
	"./douyin/6.jpg": 9727,
	"./kuaishou/1.jpg": 3859,
	"./kuaishou/2.jpg": 2228,
	"./kuaishou/3.jpg": 273,
	"./kuaishou/4.jpg": 2258,
	"./xiaohongshu/1.jpg": 789,
	"./xiaohongshu/2.jpg": 8714,
	"./xiaohongshu/3.jpg": 6455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9994;